import React, { useState } from 'react';
import { CheckCircle2, Trash2, FileText } from 'lucide-react';
import { Button, Form } from 'react-bootstrap';
import VatVerificationViewModal from '../VatVerificationViewModal';

const RecordStep = ({
    recordVerification,
    handleDeleteVerification,
    handleCreateRecordVerification,
    vatPeriod,
    operationInProgress,
    isPreviewMode
}) => {
    const [showVerificationModal, setShowVerificationModal] = useState(false);
    const [recordDate, setRecordDate] = useState(vatPeriod?.due_date || '');
    const isCompleted = !!recordVerification;

    return (
        <div className="step-container">
            <div className="step-content">
                {isCompleted ? (
                    <>
                        <div className="text-center py-4">
                            <CheckCircle2 size={48} className="text-success mb-3" />
                            <h4 className="mb-2" style={{ color: '#166534' }}>Momsperioden är slutförd</h4>
                            <p className="text-muted">Alla steg har hanterats och bokförts.</p>
                        </div>

                        <div className="d-flex align-items-center justify-content-between">
                            <button
                                type="button"
                                onClick={() => setShowVerificationModal(true)}
                                className="d-inline-flex align-items-center gap-2 border-0 bg-transparent p-0"
                                style={{ fontSize: '0.85rem', cursor: 'pointer' }}
                            >
                                <CheckCircle2 size={16} className="text-success" />
                                <span style={{ color: '#166534', fontWeight: 500, textDecoration: 'underline', textUnderlineOffset: '2px' }}>
                                    Verifikat {recordVerification.series}{recordVerification.number}
                                </span>
                            </button>
                            {vatPeriod?.state === 'open' && (
                                <Button
                                    variant="link"
                                    size="sm"
                                    className="text-danger p-0"
                                    onClick={() => handleDeleteVerification(recordVerification.verification_id, 'record')}
                                    disabled={operationInProgress || isPreviewMode}
                                    style={{ fontSize: '0.8rem' }}
                                >
                                    <Trash2 size={13} className="me-1" />
                                    Ångra
                                </Button>
                            )}
                        </div>

                        <VatVerificationViewModal
                            show={showVerificationModal}
                            onHide={() => setShowVerificationModal(false)}
                            verificationId={recordVerification.verification_id}
                        />
                    </>
                ) : (
                    <>
                        <p className="text-muted mb-3" style={{ fontSize: '0.875rem' }}>
                            Skapa verifikat för när Skatteverket drar momsen från skattekontot (2650 → 1630).
                        </p>

                        <div className="d-flex align-items-end gap-3 mb-3">
                            <Form.Group style={{ width: '180px' }}>
                                <Form.Label className="small text-muted mb-1">Datum för dragning</Form.Label>
                                <Form.Control
                                    type="date"
                                    size="sm"
                                    value={recordDate}
                                    onChange={(e) => setRecordDate(e.target.value)}
                                    disabled={isPreviewMode}
                                />
                            </Form.Group>
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={() => handleCreateRecordVerification(recordDate)}
                                disabled={operationInProgress || isPreviewMode || !recordDate}
                                className="d-inline-flex align-items-center"
                            >
                                <FileText size={16} className="me-2" />
                                Skapa verifikat
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default RecordStep;
